import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import styles from './CapthEtat.module.css';

export const CaptchEtat = forwardRef (function CaptchEtat(props, ref) {
    const captchaStyleName = props['captchaStyleName'];
    const urlBackend = props['urlBackend'];
    const altImage = props['altImage'] ?? 'Recopier le code de sécurité de cette image';
    const onChange = props.onChange;
    const [captcha, setCaptcha] = useState({});
    const [audioTitle, setAudioTitle] = useState('');
    const [reloadTitle, setReloadTitle] = useState('');

    useEffect(() => {
            fetchData();
            if (captchaStyleName.includes('FR')){
                setAudioTitle('Bouton audio');
                setReloadTitle('Bouton de rechargement');
            }
            else{
                setAudioTitle('Audio button');
                setReloadTitle('Reload button');
            }
    }, [captchaStyleName]);

    const fetchData = async () => {
        try {
            const response = await fetch(`${urlBackend}?get=image&c=${captchaStyleName}`);
            if (!response.ok) {
                throw new Error('Erreur lors de la récupération du captcha');
            }

            const jsonData = await response.json();
            setCaptcha(jsonData);
            onChange(jsonData);
        } catch (error) {
            console.error('Erreur lors de la récupération du captcha');
        }
    };

    useImperativeHandle(ref, () => ({
        reloadImage: () => {
            fetchData();
        }
    }));

    const refresh = () => {
        fetchData();
    };


    const playSound = async () => {
        let url = `${urlBackend}?get=sound&c=${captchaStyleName}&t=`+captcha.uuid;
        try{
            await new Audio(url).play();
        }catch(error){
            console.error('Erreur lors de la récupération du son');
            refresh();
        }
    }

    return (
        <div className={styles.captchaForm} id={'captchaComponent'}>
            <img src={captcha?.imageb64} alt={altImage} id="captchaImage"/>
            <div className={styles.logos} id={'logos'}>
                <button type="button" title={audioTitle} className="btn" onClick={playSound}
                        id="playSoundIcon"
                        alt="Énoncer le code du captcha">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="25" height="25" viewBox="0 0 75 75"
                         id="iconSound">
                        <path
                            d="M39.389,13.769 L22.235,28.606 L6,28.606 L6,47.699 L21.989,47.699 L39.389,62.75 L39.389,13.769z"
                            style={{ fill: '#111', stroke: '#111', strokeWidth: 5, strokeLinejoin: 'round' }}/>
                        <path
                            d="M48,27.6a19.5,19.5 0 0 1 0,21.4M55.1,20.5a30,30 0 0 1 0,35.6M61.6,14a38.8,38.8 0 0 1 0,48.6"
                            style={{ fill: 'none', stroke: '#111', strokeWidth: 5, strokeLinecap: 'round' }}/>
                    </svg>
                </button>
                <button type="button" title={reloadTitle} onClick={refresh} className="btn"
                        id="reloadCaptchaIcon"
                        alt="Générer un nouveau captcha">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 17 20" fill="none"
                         id="iconReload">
                        <path
                            d="M9.00003 4.0001C11.1 4.0001 13.1 4.8001 14.6 6.3001C17.7 9.4001 17.7 14.5001 14.6 17.6001C12.8 19.5001 10.3 20.2001 7.90003 19.9001L8.40003 17.9001C10.1 18.1001 11.9 17.5001 13.2 16.2001C15.5 13.9001 15.5 10.1001 13.2 7.7001C12.1 6.6001 10.5 6.0001 9.00003 6.0001V10.6001L4.00003 5.6001L9.00003 0.600098V4.0001ZM3.30003 17.6001C0.700029 15.0001 0.300029 11.0001 2.10003 7.9001L3.60003 9.4001C2.50003 11.6001 2.90003 14.4001 4.80003 16.2001C5.30003 16.7001 5.90003 17.1001 6.60003 17.4001L6.00003 19.4001C5.00003 19.0001 4.10003 18.4001 3.30003 17.6001V17.6001Z"
                            style={{ fill: 'black'}}/>
                    </svg>
                </button>
            </div>
        </div>
    );
}, []);
